/* 根据颜色名称映射色值,涂到 [data-color-name] 圆点上。不做图片取色 */
if (!window.SolidSwatch) {
  window.SolidSwatch = (function () {
    var MAP = {
      white: '#fafafa', snowwhite: '#fbfbfb', offwhite: '#f5f2ec', pearl: '#eae0c8',
      cream: '#f8f0e2', creamwhite: '#f8f0e2', creamywhite: '#f8f0e2',
      ivory: '#f8f4e6', beige: '#e8dcc8', oatmeal: '#d8cdba',
      sand: '#d9c7a7', nude: '#e3c6ad', champagne: '#f7e7ce', milktea: '#c9a98b',
      apricot: '#f7c59f', peach: '#ffc8a2', coral: '#ff7f66', salmon: '#fa8072',
      watermelon: '#f4586d', rose: '#e75480', pink: '#f5a9c1', babypink: '#f4c2c2',
      dustypink: '#d8a7b1', hotpink: '#ff69b4', cherry: '#c40233',
      red: '#d0312d', wine: '#722f37', winered: '#722f37', burgundy: '#800020',
      maroon: '#800000', brick: '#9c4a3c', rust: '#b7410e', scarlet: '#e8321e',
      orange: '#f28c28', amber: '#e8a317', mustard: '#d4a017', yellow: '#f7d21e',
      lemon: '#f5e050', gold: '#d4af37',
      khaki: '#c3b091', olive: '#708238', armygreen: '#4b5320', sage: '#9caf88',
      matcha: '#a8c66c', mint: '#98e2c6', grassgreen: '#7cbb45', applegreen: '#8db600',
      green: '#2e8b57', forestgreen: '#228b22', darkgreen: '#1e5631', emerald: '#3fa672',
      teal: '#0e7c7b', tiffany: '#81d8d0', turquoise: '#40e0d0', cyan: '#22b8cf',
      tidewater: '#c4d8d2', seafoam: '#c2e0d5',
      lakeblue: '#4f94cd', skyblue: '#87ceeb', babyblue: '#89cff0', blue: '#3b6bc7',
      royalblue: '#4169e1', cobalt: '#0047ab', denim: '#4667a2', navy: '#1f2a44',
      navyblue: '#1f2a44', midnight: '#191970', midnightblue: '#191970', indigo: '#4b0082',
      violet: '#8f00ff', lavender: '#b9a2d8', lilac: '#c8a2c8', purple: '#7d4b9e',
      amethyst: '#9966cc', amberpurple: '#8e5a9e', plum: '#8e4585', grape: '#6f2da8',
      magenta: '#d0417e', fuchsia: '#ce2c8f',
      brown: '#7b4a2d', cocoa: '#4f2d1c', coffee: '#6f4e37', mocha: '#8a624a', chocolate: '#5d3a1a',
      caramel: '#c68e5b', camel: '#c19a6b', tan: '#d2b48c', taupe: '#8b8589',
      copper: '#b87333', ancientcopper: '#8a5a3b', bronze: '#cd7f32',
      grey: '#9a9a9a', gray: '#9a9a9a', lightgrey: '#cfcfcf', lightgray: '#cfcfcf',
      darkgrey: '#4a4a4a', darkgray: '#4a4a4a', charcoal: '#36454f', graphite: '#41424c',
      smoke: '#a9a9ae', gunmetal: '#2a3439', silver: '#c0c0c0',
      black: '#141414'
    };

    function resolve(name) {
      if (!name) return null;
      /* 1. 精确匹配对照表 */
      if (MAP[name]) return MAP[name];
      /* 2. 标准CSS颜色名 */
      if (window.CSS && CSS.supports && CSS.supports('color', name)) return name;
      /* 3. 包含已知颜色名时取最长匹配 (如 ancientcopperx → ancientcopper) */
      var best = null;
      for (var k in MAP) {
        if (name.indexOf(k) > -1 && (!best || k.length > best.length)) best = k;
      }
      if (best) return MAP[best];
      return null;
    }

    function paintAll(root) {
      (root || document).querySelectorAll('[data-color-name]:not([data-swatch-done])').forEach(function (el) {
        el.setAttribute('data-swatch-done', '1');
        var c = resolve(el.getAttribute('data-color-name'));
        if (c) el.style.backgroundColor = c;
      });
    }

    function init() {
      paintAll();
      new MutationObserver(function () {
        paintAll();
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    return { paintAll: paintAll, map: MAP };
  })();
}
